import { types } from 'mobx-state-tree';

const ModelVersionTrainingLogWindow = types.model('ModelVersionTrainingLogWindow', {
  id: types.identifier, // model version id
});

const TrainingLogsStore = types
  .model('TrainingLogsStore', {
    training_logs_windows: types.map(ModelVersionTrainingLogWindow),
  })
  .actions((self) => ({
    createTrainingLogWindow(modelVersionId: string) {
      const newWindow = ModelVersionTrainingLogWindow.create({ id: modelVersionId });
      self.training_logs_windows.put(newWindow);
    },
    removeTrainingLogWindow(modelVersionId: string) {
      self.training_logs_windows.delete(modelVersionId);
    },
  }))
  .views((self) => ({
    getTrainingLogWindow(modelVersionId: string) {
      return self.training_logs_windows.get(modelVersionId);
    },
  }));

export const withTrainingLogWindows = () => TrainingLogsStore;
